module.exports = __webpack_public_path__ + "img/backTop.9631a289.png";